import {Component, Input} from '@angular/core';
import {Werte} from '../../models/werte.model';
import {
  TypeConfig,
  HEIZUNG_CONFIG,
  KALTWASSER_CONFIG,
  WARMWASSER_CONFIG
} from '../../models/overviewTypeConfig.model';

@Component({
  selector: 'mp-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent {
  @Input() werte: Werte;
  @Input() hatHeizung: boolean;
  @Input() hatWarmwasser: boolean;
  @Input() hatKaltwasser: boolean;
  overviewTypeHeizung: TypeConfig = HEIZUNG_CONFIG;
  overviewTypeKaltwasser: TypeConfig = KALTWASSER_CONFIG;
  overviewTypeWarmwasser: TypeConfig = WARMWASSER_CONFIG;

}
